module.exports = __webpack_public_path__ + "img/stock4.5fe23b7c.png";